import * as Api from '@ViewModels';
import * as React from 'react';
import { normalizeFacebookPageHandle, useFacebookPageLookupQuery } from './useFacebookPageLookupQuery';

export function useFacebookPageAutoCompleteViewModel({
	enabled = true,
	forUserId,
	impersonationContext,
}: {
	enabled?: boolean;
	forUserId?: string;
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const [searchQuery, setSearchQuery] = React.useState('');
	const normalizedHandle = normalizeFacebookPageHandle(searchQuery);
	const lookupQuery = useFacebookPageLookupQuery({
		handle: normalizedHandle,
		enabled,
		forUserId,
		impersonationContext,
	});

	const searchResults = React.useMemo(() => {
		// Deploys may briefly pair this client with the prior single-result API.
		const pages = Array.isArray(lookupQuery.data) ? lookupQuery.data : [];
		return pages.filter(page => !!page?.pageId);
	}, [lookupQuery.data]);

	return React.useMemo(
		() =>
			({
				isBusy: lookupQuery.isLoading || lookupQuery.isFetching,
				reset: () => setSearchQuery(''),
				searchResults,
				setSearchQuery: (value?: string) => setSearchQuery(value || ''),
				totalCount: searchResults.length,
			}) as Api.AutoCompleteViewModel<Api.IFacebookPageLookupResult>,
		[lookupQuery.isFetching, lookupQuery.isLoading, searchResults]
	);
}
